import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { ShineEffect, GlowOrb } from "../../../Components/Effects";

const getInitialAuthDarkMode = () => {
  if (typeof window === "undefined") return false;
  const storedValue = localStorage.getItem("admin-dark-mode");
  if (storedValue !== null) return storedValue === "true";
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ?? false;
};

const AuthLayout = () => {
  const [dark] = useState(getInitialAuthDarkMode);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
  }, [dark]);

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-100 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(251,146,60,0.10),_transparent_25%),radial-gradient(circle_at_bottom_right,_rgba(15,23,42,0.08),_transparent_30%)] dark:bg-[radial-gradient(circle_at_top_left,_rgba(251,146,60,0.12),_transparent_22%),radial-gradient(circle_at_bottom_right,_rgba(30,41,59,0.4),_transparent_30%)]" />
      <GlowOrb className="top-[-120px] left-[-120px]" size={420} color="rgba(251, 146, 60, 0.18)" duration={9} />
      <GlowOrb className="bottom-[-160px] right-[-160px]" size={460} color="rgba(15, 23, 42, 0.10)" duration={11} />
      <ShineEffect duration={7} />
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-10">
        <Outlet />
      </div>
      <ToastContainer />
    </div>
  );
};
export default AuthLayout;
